<div [class.loader-hidden]="show" class="step">
    <div class="loader-overlay">
        <div>
            <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </div>
    </div>
</div>
